import { ScriptConfigModel } from '../../../shared/models';

export const CookiesConfigScripts: Record<string, ScriptConfigModel[]> = {
  TECHNICAL_COOKIES: [],
};
